import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/_services/auth/auth.service';
import { NotifService } from 'src/app/_services/notif.service';
import { ParamService } from 'src/app/_services/parc-service/param-service/param-service';
import { MarquePneuService } from 'src/app/_services/pneumatique/marque_pneu/marque-pneu.service';
import Swal from 'sweetalert2';
declare const $;

@Component({
  selector: 'app-mark-pneu-all',
  templateUrl: './mark-pneu-all.component.html',
  styleUrls: ['./mark-pneu-all.component.scss']
})
export class MarkPneuAllComponent implements OnInit {

  mark_pneus: any;
  loading: boolean = true;
  @BlockUI() blockUI: NgBlockUI;

  //SweetAlert Text
  areYouSure = '';
  warning = ''
  yes = '';
  no = '';
  deleted = '';
  deletedMessage = '';
  cancelled = '';
  cancelledMessage = '';
  canCreate = false;
  canUpdate = false;
  canDelete = false;
  page = 1;
  data: any;
  detailform: any;

  constructor(
    private MarquePneuService: MarquePneuService,
    private paramService: ParamService,
    private toastrService: ToastrService,
    private authService: AuthService,
    private notifService: NotifService,
    private translate: TranslateService,
    private router: Router,
  ) {
    this.translate.get(
      ['SweetAlert.AreYouSure', 'SweetAlert.Warning', 'SweetAlert.Yes', 'SweetAlert.No', 'SweetAlert.Deleted',
        'SweetAlert.DeletedMessage', 'SweetAlert.Cancelled', 'SweetAlert.CancelledMessage'],
      { data: "cette marque de pneu" })
      .subscribe(val => {
        this.areYouSure = val['SweetAlert.AreYouSure'];
        this.warning = val['SweetAlert.Warning'];
        this.yes = val['SweetAlert.Yes'];
        this.no = val['SweetAlert.No'];
        this.deleted = val['SweetAlert.Deleted'];
        this.deletedMessage = val['SweetAlert.DeletedMessage'];
        this.cancelled = val['SweetAlert.Cancelled'];
        this.cancelledMessage = val['SweetAlert.CancelledMessage'];
      });
   }

  ngOnInit(): void {
    this.getMarkPneu(this.page);
  }

  getMarkPneu(page) {
    this.loading = true;
    this.MarquePneuService.gets(page).then(
      response => {
        this.mark_pneus = response;
        console.log(this.mark_pneus);
        $(function () {
          $("#example1").DataTable({
            "responsive": true, "lengthChange": false, "autoWidth": false,
            "buttons": ["copy", "csv", "excel", "pdf", "print", "colvis"]
          }).buttons().container().appendTo('#example1_wrapper .col-md-6:eq(0)');
        });
      }
    ).catch(
      error => {
        this.notifService.danger(error.error.message)
      }
    ).finally(
      () => {
        this.loading = false;
      }
    );
  }


  getPage(url) {
    if (url) {
      this.MarquePneuService.get(url).then((res) => {
        this.mark_pneus = res;
        console.log(this.mark_pneus);
      }).catch(
        error => {
          this.notifService.danger(error.error.message);
        }
      ).finally(
        () => {
          this.loading = false;
        }
      )
    }
  }

  editMarquePneu(id) {
    console.log('bonjour');
    this.router.navigate(['/mark-pneu/update/' + id]);

  }

  detailsMarquePneu(model: any) {
    this.MarquePneuService.find(model.id).then(

      data => {
        this.detailform = data
        Swal.fire({
          title: data.name,
          text: data.description,
          icon: 'info',
          confirmButtonText: 'Retour',
        })
      }

    ).catch(
      error => {
        console.log(error)
        this.blockUI.stop();
        this.toastrService.error('Echec de suppression');
      }
    )
  }

  deleteMarquePneu(id) {
    Swal.fire({
      title: this.areYouSure,
      text: this.warning,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.yes,
      cancelButtonText: this.no
    }).then((result) => {
      if (result.value) {
        this.blockUI.start('Loading...');
        this.MarquePneuService.delete(id).then(
          data => {
            this.blockUI.stop();
            Swal.fire(
              this.deleted,
              this.deletedMessage,
              'success'
            );
            this.getMarkPneu(1);

          }
        ).catch(
          error => {
            console.log(error);
            this.blockUI.stop();
            this.translate.get('MarquePneu.' + error.error.code)
              .subscribe(val => this.notifService.danger(val));
          }
        );

      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(
          this.cancelled,
          this.cancelledMessage,
          'error'
        );
      }
    });
  }


}
